import { Injectable, EventEmitter } from '@angular/core';
import { Subject, map, of } from 'rxjs';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CURRENT_ENVIROMENT, quoteLevelConstants, SERVICE_END_POINT, STORE_VAL } from '../../../shared';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store/state/app.state';
import * as QuotePlaybackRiskWarningActions from '../../../store/actions/playback-risk-warnings.actions';
import * as RefNoActions from '../../../store/actions/reference-number.actions';
import * as ClearToApplyActions from '../../../store/actions/clear-to-apply.actions';
import * as BeforeStartActions from '../../../store/actions/before-start.actions';
import * as GuidanceAndAdviceActions from '../../../store/actions/guidance-and-advice.actions';
import * as PersDetailsActions from '../../../store/actions/personal-details.actions';
import { YourPension } from '../../../model/ngrx/your-pension.model';
import * as UserDataConfig from '../../../pages/quote-calculation/config/user-data.config';
import * as UserDataConfigUserDetail from '../../../pages/user-details/config/user-data.config';
import * as BreadCrumDataConfig from '../../../common-components/config/user-data.config';
import * as YourPensionActions from '../../../store/actions/your-pension.actions';
import * as ProductChoiceActions from '../../../store/actions/product-choice.actions';
import * as ReqQuoteCalcActions from '../../../store/actions/request-quote-calculation.actions';
import { ProductChoice } from '../../../model/ngrx/Product-Choice.model';
import { DependantDetails } from '../../../model/ngrx/dependant-details.model';
import * as DepDetailsActions from '../../../store/actions/dependant-details.actions';
import * as resDataCalculationActions from '../../../store/actions/response-quote-calculation.actions';
import * as resDataCaptureActions from '../../../store/actions/response-quote-datacapture.actions';
import * as underWritingDataAction from '../../../pages/medical-underwriting/store/actions/underwriting-ho.action';
import { UnderWritingData, AnnuitantMedicalConditions } from '../../../pages/medical-underwriting/model/lifestyle.post.model';
import * as LifeStyleActions from '../../../pages/medical-underwriting/store/actions/lifestyle.action';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import * as paymentDetailsActions from '../../../store/actions/payment-details.actions';
import * as yourPersonalDetailsActions from '../../../store/actions/your-personal-details.actions';
import * as HealthRecordsActions from '../../../store/actions/health-records.actions';
import * as DepHealthRecordsActions from '../../../store/actions/dep-health-records.actions';
import * as yourDependantDetailsActions from '../../../store/actions/your-dependant-details.actions';
import * as beneficiaryDetailsActions from '../../../store/actions/beneficiary-details.actions';
import * as yourProductApplicationActions from '../../../store/actions/your-product-application.actions';
import * as YourPensionSavings from '../../../store/actions/your-pension-savings.actions';
import * as UserDataConfigBreadCrumbs from '../../../common-components/config/user-data.config';
import { MEDICAL_UW_URL } from 'src/app/shared/constants/medical-uw-url.constants';
import * as resApplicationCaptureActions from '../../../store/actions/response-applicationDataCapture.actions';
import { FormGroup } from '@angular/forms';
import { ParentFormAndElmModel } from 'src/app/model/key-value-modal';
import { InvalidCtlNameObj } from 'src/app/pages/medical-underwriting/model/mcUserJourney.model';
import { UtilityServiceForMedicalService } from '../../../pages/medical-underwriting/services/utility-service';
import * as YourLumpSumActions from '../../../store/actions/your-lump-sum-allowances.actions';


@Injectable({
  providedIn: 'root'
})
export class UtilService {
  serverDetail;
  displayAlert;  
  quoteResulRes: any;
  constructor(private http: HttpClient, private store: Store<AppState>, private router: Router,
    private utilityServiceForMedicalService: UtilityServiceForMedicalService) {
    this.serverDetail = UserDataConfigBreadCrumbs.BreadcrumbConfig.authServer;
    store.select(STORE_VAL.quote_result).subscribe(res => {
      if (res.length > 0) {
        this.quoteResulRes = res[0];
      }
    });
  }
  public emitCard = new Subject<any>();
  public emitSlider = new Subject<any>();
  public emitToggle = new Subject<any>();
  public emitDropdown = new Subject<any>();
  public emitInput = new Subject<any>();
  public emitGrid = new Subject<any>();
  public emitbreadcrumb = new Subject<any>();
  public emitbreadcrumbAfterLogin = new Subject<any>();
  public afterSaveSuccessfullyLogin = new Subject<any>();
  public resetEditMode = new Subject<any>();
  public updateEditForm = new Subject<any>();
  private endPoints = SERVICE_END_POINT[CURRENT_ENVIROMENT.environment];
  public islocked = new BehaviorSubject<boolean>(false);
  public isLocked$ = this.islocked.asObservable();
  private parentFormAndElmModelObj: ParentFormAndElmModel;
  invalidDataEvt = new EventEmitter();
  public pwAppointmentdate$ = new BehaviorSubject("");
  public popUpGuidanceAndAdvice$ = new BehaviorSubject("");

  showLockedAlert(value: boolean) {
    this.islocked.next(value);
  }
  setEdifFields(value: any) {
    this.emitCard.next(value);
  }
  refreshSlider(obj?: any) {
    this.emitSlider.next(obj);
  }
  refreshSliderWithValue(value: any) {
    this.emitSlider.next(value);
  }
  refreshToggleButton() {
    this.emitToggle.next({});
  }
  refreshDateDropdown() {
    this.emitDropdown.next({});
  }
  refreshInput() {
    this.emitInput.next({});
  }
  refreshGrid() {
    this.emitGrid.next({});
  }
  refreshBreadcrumb(value: any) {
    this.emitbreadcrumb.next(value);
  }
  loadBreadcrumpAfterLogin(value: any) {
    this.emitbreadcrumbAfterLogin.next(value);
  }
  afterSaveSuccesfully() {
    this.afterSaveSuccessfullyLogin.next(({}));
  }
  resetEditModeMU() {
    this.resetEditMode.next({});
  }
  updateFormAfterEdit(value: any) {
    this.updateEditForm.next(value);
  }
  
  emitInvalidMessageEvt(value: InvalidCtlNameObj) {
    this.invalidDataEvt.emit(value);    
  }

  setParentFormToValidate(value: ParentFormAndElmModel) {
    this.parentFormAndElmModelObj = null;
    this.parentFormAndElmModelObj = value;
  }

  getParentFormToValidate(): ParentFormAndElmModel {
    return this.parentFormAndElmModelObj;
  }

  // session expire service
  sessionExtend(): Observable<any> {

    return this.http.get(this.endPoints.extendSessionUrl).pipe(map((res: Response) => {
      return res;
    }));

  }

  logout() {
    return this.http.get(this.endPoints.logoutURL).pipe(map((res: Response) => {
      return res;
    }));
  }
  // tslint:disable-next-line:max-line-length
  restoreAllApplicationStore(applicationRef: string, isResumeApplication: boolean, isResumeQuoteOtherProd: boolean,
    applicationData: any, resposeJsonLoggedInDetailStore: any, isViewApplication = false, isExpectedDateExpired = false) {
    const partialApplication = applicationData;
    // restore reference store data
    this.store.dispatch(new RefNoActions.RemoveReferenceNumber(0));
    this.store.dispatch(new RefNoActions.AddReferenceNumber({
      editMode: false,
      formSessionId: partialApplication.formSessionId,
      // tslint:disable-next-line: max-line-length
      quoteNumberFlag: 1,
      quoteReferenceNumber: partialApplication?.quoteRefs[0],
      applicationRefNumber: partialApplication.applicationId
    }));

    // clear-to-apply store data
    this.store.dispatch(new ClearToApplyActions.RemoveClearToApply(0));
    this.store.dispatch(new YourLumpSumActions.RemoveYourLumpSumAllowances(0));
    const clearToApplytriskAndStaticQuestion = [];
    const yourLumpSumAllowanceQuestion = [];
    if (partialApplication.riskAndStaticQuestion == null) {
      partialApplication.riskAndStaticQuestion = [];
    }
    partialApplication.riskAndStaticQuestion.forEach(question => {
      // tslint:disable-next-line:max-line-length
      if (question.questionCode === 'lifeTimeAllowance' || question.questionCode === 'pensionPolicy' || question.questionCode === 'guaranteedStartDate') {
        clearToApplytriskAndStaticQuestion.push(question);
      }
      if (question.questionCode === 'lsaQuestion' || question.questionCode === 'lsDbaQuestion' || question.questionCode === 'lsaLgaProtectionQuestion') {
        yourLumpSumAllowanceQuestion.push(question);
      }
    });
    this.store.dispatch(new ClearToApplyActions.AddClearToApply({
      // tslint:disable-next-line:max-line-length
      bankrupt: partialApplication.riskAndStaticQuestion.find(q => q.questionCode === 'bankruptQuestion') ? partialApplication.riskAndStaticQuestion.find(q => q.questionCode === 'bankruptQuestion').answer : null,
      // tslint:disable-next-line: max-line-length
      lifeTimeAllowance: partialApplication.riskAndStaticQuestion.find(q => q.questionCode === 'lifeTimeAllowanceQuestion') ? partialApplication.riskAndStaticQuestion.find(q => q.questionCode === 'lifeTimeAllowanceQuestion').answer : null,
      // tslint:disable-next-line: max-line-length
      pensionPolicy: partialApplication.riskAndStaticQuestion.find(q => q.questionCode === 'pensionPolicyQuestion') ? partialApplication.riskAndStaticQuestion.find(q => q.questionCode === 'pensionPolicyQuestion').answer : null,
      // tslint:disable-next-line: max-line-length
      guaranteedStartDate: partialApplication.riskAndStaticQuestion.find(q => q.questionCode === 'guaranteedStartDateQuestion') ? partialApplication.riskAndStaticQuestion.find(q => q.questionCode === 'guaranteedStartDateQuestion').answer : null,
      // tslint:disable-next-line:max-line-length
      ltaProtection: partialApplication.riskAndStaticQuestion.find(q => q.questionCode === 'ltaProtectionQuestion') ? partialApplication.riskAndStaticQuestion.find(q => q.questionCode === 'ltaProtectionQuestion').answer : null,
      // tslint:disable-next-line:max-line-length
      ltaProtectionType: partialApplication.ltaProtectionType ? partialApplication.ltaProtectionType : null,
      riskAndStaticQuestion: clearToApplytriskAndStaticQuestion
    }));
   
    this.store.dispatch(new YourLumpSumActions.AddYourLumpSumAllowances({
      lsaQuestion: partialApplication.riskAndStaticQuestion.find(q => q.questionCode === 'lsaQuestion') ? partialApplication.riskAndStaticQuestion.find(q => q.questionCode === 'lsaQuestion').answer : null,
      // tslint:disable-next-line:max-line-length
      lsDbaQuestion: partialApplication.riskAndStaticQuestion.find(q => q.questionCode === 'lsDbaQuestion') ? partialApplication.riskAndStaticQuestion.find(q => q.questionCode === 'lsDbaQuestion').answer : null,
      lsaLgaProtectionQuestion: partialApplication.riskAndStaticQuestion.find(q => q.questionCode === 'lsaLgaProtectionQuestion') ? partialApplication.riskAndStaticQuestion.find(q => q.questionCode === 'lsaLgaProtectionQuestion').answer : null,
      protectionType: partialApplication.protectionType ? partialApplication.protectionType :  null,
      riskAndStaticQuestion: yourLumpSumAllowanceQuestion

    }));
    // start personal detail page
    this.store.dispatch(new yourPersonalDetailsActions.RemoveYourPersonalDetails(0));
    this.store.dispatch(new yourPersonalDetailsActions.AddYourPersonalDetails({
      title: partialApplication.customer && partialApplication.customer.title ? partialApplication.customer.title : null,
      otherTitle: partialApplication.customer && partialApplication.customer.otherTitle ? partialApplication.customer.otherTitle : null,
      forename: partialApplication.customer && partialApplication.customer.forename ? partialApplication.customer.forename : null,
      surname: partialApplication.customer && partialApplication.customer.surname ? partialApplication.customer.surname : null,
      middleName: partialApplication.customer && partialApplication.customer.middleName ? partialApplication.customer.middleName : null,
      thirdName: partialApplication.customer && partialApplication.customer.thirdName ? partialApplication.customer.thirdName : null,
      dateOfBirth: partialApplication.customer && partialApplication.customer.dateOfBirth ? partialApplication.customer.dateOfBirth : null,
      maritalStatus: partialApplication.customer && partialApplication.customer.maritalStatus ? partialApplication.customer.maritalStatus : null,
      gender: partialApplication.customer && partialApplication.customer.gender ? partialApplication.customer.gender : null,
      emailAddress: partialApplication.customer && partialApplication.customer.emailAddress ? partialApplication.customer.emailAddress : null,
      confirmEmailAddress: partialApplication.customer && partialApplication.customer.emailAddress ? partialApplication.customer.emailAddress : null,
      address: partialApplication.customer && partialApplication.customer.address ? partialApplication.customer.address : null,
      mobilePhone: partialApplication.customer && partialApplication.customer.mobilePhone ? partialApplication.customer.mobilePhone : null,
      homePhone: partialApplication.customer && partialApplication.customer.homePhone ? partialApplication.customer.homePhone : null,
      nino: partialApplication.customer && partialApplication.customer.nino ? partialApplication.customer.nino : null,
      internalSoftOptInInd: partialApplication.customer && partialApplication.customer.internalSoftOptInInd ? partialApplication.customer.internalSoftOptInInd : null,
    }));
    // end personal detail page

    // health Record start
    this.store.dispatch(new HealthRecordsActions.RemoveHealthRecords(0));
    this.store.dispatch(new HealthRecordsActions.AddHealthRecords({
      partyType: partialApplication.annuitantDoctor && partialApplication.annuitantDoctor.partyType
        ? partialApplication.annuitantDoctor.partyType : null,
      organisationName: partialApplication.annuitantDoctor && partialApplication.annuitantDoctor.organisationName
        ? partialApplication.annuitantDoctor.organisationName : null,
      addressline1: partialApplication.annuitantDoctor && partialApplication.annuitantDoctor.address && partialApplication.annuitantDoctor.address.line1
        ? partialApplication.annuitantDoctor.address.line1 : null,
      addressline2: partialApplication.annuitantDoctor && partialApplication.annuitantDoctor.address && partialApplication.annuitantDoctor.address.line2
        ? partialApplication.annuitantDoctor.address.line2 : null,
      addressline3: partialApplication.annuitantDoctor && partialApplication.annuitantDoctor.address && partialApplication.annuitantDoctor.address.line3
        ? partialApplication.annuitantDoctor.address.line3 : null,
      addressline4: partialApplication.annuitantDoctor && partialApplication.annuitantDoctor.address && partialApplication.annuitantDoctor.address.line4
        ? partialApplication.annuitantDoctor.address.line4 : null,
      emailAddress: partialApplication.annuitantDoctor && partialApplication.annuitantDoctor.emailAddress
        ? partialApplication.annuitantDoctor.emailAddress : null,
      contactNumber: partialApplication.annuitantDoctor && partialApplication.annuitantDoctor.contactNumber
        ? partialApplication.annuitantDoctor.contactNumber : null,
      title: partialApplication.annuitantDoctor && partialApplication.annuitantDoctor.title
        ? partialApplication.annuitantDoctor.title : null,
      forename: partialApplication.annuitantDoctor && partialApplication.annuitantDoctor.forename
        ? partialApplication.annuitantDoctor.forename : null,
      middleName: partialApplication.annuitantDoctor && partialApplication.annuitantDoctor.middleName
        ? partialApplication.annuitantDoctor.middleName : null,
      surname: partialApplication.annuitantDoctor && partialApplication.annuitantDoctor.surname
        ? partialApplication.annuitantDoctor.surname : null,
      thirdName: partialApplication.annuitantDoctor && partialApplication.annuitantDoctor.thirdName
        ? partialApplication.annuitantDoctor.thirdName : null,
      postcode: partialApplication.annuitantDoctor && partialApplication.annuitantDoctor.address && partialApplication.annuitantDoctor.address.postcode
        ? partialApplication.annuitantDoctor.address.postcode : null,
      annReportViewReqInd: partialApplication.annuitantDoctor && partialApplication.annuitantDoctor.annReportViewReqInd
        ? partialApplication.annuitantDoctor.annReportViewReqInd : null,
      countryCode: partialApplication.annuitantDoctor && partialApplication.annuitantDoctor.address && partialApplication.annuitantDoctor.address.countryCode
        ? partialApplication.annuitantDoctor.address.countryCode : null,
      ukAddressIndicator: partialApplication.annuitantDoctor && partialApplication.annuitantDoctor.ukAddressIndicator
        ? partialApplication.annuitantDoctor.ukAddressIndicator : null
    }));
    // health record end

    // dependant-health record store
    this.store.dispatch(new DepHealthRecordsActions.RemoveDepHealthRecords(0));
    this.store.dispatch(new DepHealthRecordsActions.AddDepHealthRecords({
      partyType: (partialApplication.dependantDoctor && partialApplication.dependantDoctor['partyType'])
        ? partialApplication.dependantDoctor['partyType'] : null,
      organisationName: (partialApplication.dependantDoctor && partialApplication.dependantDoctor['organisationName'])
        ? partialApplication.dependantDoctor['organisationName'] : null,
      addressline1: (partialApplication.dependantDoctor && partialApplication.dependantDoctor['address'] && partialApplication.dependantDoctor['address']['line1'])
        ? partialApplication.dependantDoctor['address']['line1'] : null,
      addressline2: (partialApplication.dependantDoctor && partialApplication.dependantDoctor['address'] && partialApplication.dependantDoctor['address']['line2'])
        ? partialApplication.dependantDoctor['address']['line2'] : null,
      addressline3: (partialApplication.dependantDoctor && partialApplication.dependantDoctor['address'] && partialApplication.dependantDoctor['address']['line3'])
        ? partialApplication.dependantDoctor['address']['line3'] : null,
      addressline4: (partialApplication.dependantDoctor && partialApplication.dependantDoctor['address'] && partialApplication.dependantDoctor['address']['line4'])
        ? partialApplication.dependantDoctor['address']['line4'] : null,
      emailAddress: (partialApplication.dependantDoctor && partialApplication.dependantDoctor['emailAddress'])
        ? partialApplication.dependantDoctor['emailAddress'] : null,
      contactNumber: (partialApplication.dependantDoctor && partialApplication.dependantDoctor['contactNumber'])
        ? partialApplication.dependantDoctor['contactNumber'] : null,
      title: (partialApplication.dependantDoctor && partialApplication.dependantDoctor['title'])
        ? partialApplication.dependantDoctor['title'] : null,
      forename: (partialApplication.dependantDoctor && partialApplication.dependantDoctor['forename'])
        ? partialApplication.dependantDoctor['forename'] : null,
      middleName: (partialApplication.dependantDoctor && partialApplication.dependantDoctor['middleName'])
        ? partialApplication.dependantDoctor['middleName'] : null,
      surname: (partialApplication.dependantDoctor && partialApplication.dependantDoctor['surname'])
        ? partialApplication.dependantDoctor['surname'] : null,
      thirdName: (partialApplication.dependantDoctor && partialApplication.dependantDoctor['thirdName'])
        ? partialApplication.dependantDoctor['thirdName'] : null,
      postcode: (partialApplication.dependantDoctor && partialApplication.dependantDoctor['address'] && partialApplication.dependantDoctor['address']['postcode'])
        ? partialApplication.dependantDoctor['address']['postcode'] : null,
      depReportViewReqInd: (partialApplication.dependantDoctor && partialApplication.dependantDoctor['depReportViewReqInd'])
        ? partialApplication.dependantDoctor['depReportViewReqInd'] : null,
      countryCode: (partialApplication.dependantDoctor && partialApplication.dependantDoctor['address'] && partialApplication.dependantDoctor['address']['countryCode'])
        ? partialApplication.dependantDoctor['address']['countryCode'] : null,
      ukAddressIndicator: partialApplication.dependantDoctor && partialApplication.dependantDoctor.ukAddressIndicator
        ? partialApplication.dependantDoctor.ukAddressIndicator : null
    }));
    // bank detail store
    this.store.dispatch(new paymentDetailsActions.RemovePaymentDetails(0));
    this.store.dispatch(new paymentDetailsActions.AddPaymentDetails({
      sortcode: partialApplication.bankDetails ? partialApplication.bankDetails['sortCode'] : null,
      accountNumber: partialApplication.bankDetails ? partialApplication.bankDetails['accountNumber'] : null,
      bankName: partialApplication.bankDetails ? partialApplication.bankDetails['bankName'] : null,
      rollNumber: partialApplication.bankDetails ? partialApplication.bankDetails['rollNumber'] : null,
      accountHolder: partialApplication.bankDetails ? partialApplication.bankDetails['accountName'] : null,
      accountType: partialApplication.bankDetails && partialApplication.bankDetails.accountType === 'Y'
        ? true : null
    }));
    // dependant-details store
    this.store.dispatch(new yourDependantDetailsActions.RemoveYourDependantDetails(0));
    this.store.dispatch(new yourDependantDetailsActions.AddYourDependantDetails({
      title: partialApplication.secondLife ? partialApplication.secondLife['title'] : null,
      // tslint:disable-next-line:max-line-length
      otherTitle: partialApplication.secondLife && partialApplication.secondLife['otherTitle'] ? partialApplication.secondLife['otherTitle'] : null,
      forename: partialApplication.secondLife ? partialApplication.secondLife['forename'] : null,
      surname: partialApplication.secondLife ? partialApplication.secondLife['surname'] : null,
      middleName: partialApplication.secondLife ? partialApplication.secondLife['middleName'] : null,
      thirdName: partialApplication.secondLife ? partialApplication.secondLife['thirdName'] : null,
      dateOfBirth: partialApplication.secondLife ? partialApplication.secondLife['dateOfBirth'] : null,
      gender: partialApplication.secondLife ? partialApplication.secondLife['gender'] : null,
      maritalStatus: partialApplication.secondLife ? partialApplication.secondLife['maritalStatus'] : null,
      relationShip: partialApplication.secondLife ? partialApplication.secondLife['relationshipToCustomer'] : null,
    }));

    // beneficiary details
    this.store.dispatch(new beneficiaryDetailsActions.RemoveBeneficiaryDetails(0));
    this.store.dispatch(new beneficiaryDetailsActions.AddBeneficiaryDetails(this.newBeneficaryData(partialApplication.beneficiary, partialApplication)));

    // product application store
    this.store.dispatch(new yourProductApplicationActions.RemoveYourProductApplication(0));
    this.store.dispatch(new yourProductApplicationActions.AddYourProductApplication({
      chkAgree: partialApplication ? (partialApplication.appAgreeInd === 'true' ? true : false ) : false,
      chkSign: partialApplication ? (partialApplication.appSignedInd === 'true' ? true : false ) : false,
      updatesVia: {
        email: partialApplication.marketingConsent && partialApplication.marketingConsent['email'] === 'Y' ? true : false,
        post: partialApplication.marketingConsent && partialApplication.marketingConsent['post'] === 'Y' ? true : false,
        text: partialApplication.marketingConsent && partialApplication.marketingConsent['text'] === 'Y' ? true : false,
        telephone: partialApplication.marketingConsent && partialApplication.marketingConsent['telephone'] === 'Y' ? true : false,
        pom: partialApplication.marketingConsent && partialApplication.marketingConsent['pom'] === 'Y' ? true : false
      }
    }));
    // pension-savings data
    this.store.dispatch(new YourPensionSavings.RemovePensionSavings(0));
    this.store.dispatch(new YourPensionSavings.AddPensionSavings(partialApplication.cedingPension));

    this.store.dispatch(new resApplicationCaptureActions.RemoveApplicationDataResponse(0));
    this.store.dispatch(new resApplicationCaptureActions.AddApplicationDataResponse(partialApplication));
    if (partialApplication['quoteFundInfo'][0].productType === 'H' || partialApplication['quoteFundInfo'][0].productType === 'G') {
      this.refreshBreadcrumb({ hideApplyPagesForFTRPCorp: false });
    } else if (partialApplication['quoteFundInfo'][0].productType === 'C') {
      this.refreshBreadcrumb({ hideApplyPagesForFTRPCorp: true });
      // checks  (LTA + secondLife) and refreshes the breadcrumbs accordingly.
      if ((partialApplication['secondLife'] && partialApplication['secondLife'].dateOfBirth !== null)) {
        this.refreshBreadcrumb({ hideDependantApplyDetails: false });
      } else {
        this.refreshBreadcrumb({ hideDependantApplyDetails: true });
      }
    }
    if (partialApplication['showBeneficiary'] === true) {
      this.refreshBreadcrumb({ hideBeneficiaryApplyDetails: false });
    } else {
      this.refreshBreadcrumb({ hideBeneficiaryApplyDetails: true });
    }
    if (isViewApplication) {
      if (isExpectedDateExpired) {
        this.router.navigate([this.getScreenName(partialApplication.currentScreen)], { state: { isExpectedDateExpired } });
      } else {
        this.router.navigate([this.getScreenName(partialApplication.currentScreen)], { queryParams: { view: true } });
      }
    } else {
      this.router.navigate(['apply/clear-to-apply']);
    }

  }
  // tslint:disable-next-line: max-line-length
  restoreAllStore(quoteRefNo: string, isResumeQuote: boolean, isResumeQuoteOtherProd: boolean, quoteData: any, resposeJsonLoggedInDetailStore: any, isforHoUnderwriting = false) {
    let partialQuote = quoteData;

    //Offline to Online Dependent question
    let secondlifePercentage: number;
    let benefitBasis: any = (partialQuote.benefitBasis && partialQuote.benefitBasis.length > 0) ?
      partialQuote.benefitBasis[0] : partialQuote.benefitBasis;
    if (benefitBasis && !isNaN(benefitBasis['secondLifePensionPercentageType'])) {
      secondlifePercentage = parseInt(benefitBasis['secondLifePensionPercentageType'], 0);
    }
    if (secondlifePercentage && secondlifePercentage > 0) {
      if (!partialQuote.riskAndStaticQuestion.find(q => q.questionCode === 'dependantQuestion')) {
        partialQuote.riskAndStaticQuestion.push({
          questionCode: 'dependantQuestion',
          questionType: 'Static',
          answer: 'Y'
        });
      }
    }

    if (!isResumeQuote) {
      partialQuote.quoteBasis['commencementDate'] = '';
    }
    this.store.dispatch(new RefNoActions.RemoveReferenceNumber(0));
    this.store.dispatch(new RefNoActions.AddReferenceNumber({
      editMode: false,
      formSessionId: partialQuote.formSessionId,
      // tslint:disable-next-line: max-line-length
      quoteNumberFlag: (quoteData.benefitVariants && quoteData.benefitVariants.length > 0) ? quoteData.benefitVariants[quoteData.benefitVariants.length - 1].cardNumber : 1,
      quoteReferenceNumber: partialQuote.quoteRefNo,
      applicationRefNumber: null
    }));

    /*     condition to check whether riskstaticquestion is null and if it is null assign empty array to it
     */
    if (quoteData.riskAndStaticQuestion == null) {
      quoteData.riskAndStaticQuestion = [];
    }
    let beforeYouStartriskAndStaticQuestion = [];
    /* to check whether riskandstatic question are there or not */
    if (partialQuote.riskAndStaticQuestion && partialQuote.riskAndStaticQuestion.length >= 1) {
      partialQuote.riskAndStaticQuestion.forEach(question => {
        if (question.questionCode === 'letterPackQuestion' || question.questionCode === 'retirementOptionsQuestion' || question.questionCode === 'pensionGuidanceQuestion' || question.questionCode === 'financialAdviseQuestion') {
          beforeYouStartriskAndStaticQuestion.push(question);
        }
      });
    }
    if (partialQuote.riskAndStaticQuestion) {
      this.store.dispatch(new BeforeStartActions.AddBeforeStart({
        letterPack: partialQuote.modifiledByConsumerInd ?
          (partialQuote.riskAndStaticQuestion.find(q => q.questionCode === 'letterPackQuestion') ? partialQuote.riskAndStaticQuestion.find(q => q.questionCode === 'letterPackQuestion').answer : null) : 'Y',
        retirementOptions: partialQuote.riskAndStaticQuestion.find(q => q.questionCode === 'retirementOptionsQuestion') ? partialQuote.riskAndStaticQuestion.find(q => q.questionCode === 'retirementOptionsQuestion').answer : null,
        riskAndStaticQuestion: beforeYouStartriskAndStaticQuestion
      }));

      // Guidance and Advie store and appointment date
      let guidanceANdAdviceriskAndStaticQuestion = [];
      partialQuote.riskAndStaticQuestion.forEach(question => {
      if(question.questionCode === "bookPensionWiseAppointmentQuestion" || question.questionCode === "attendedPensionWiseAppointmentQuestion")
      guidanceANdAdviceriskAndStaticQuestion.push(question);
      });
      if(partialQuote.customer && partialQuote.customer.pwAppointmentdate) {
        this.pwAppointmentdate$.next(partialQuote.customer.pwAppointmentdate);
      }
      this.store.dispatch( new GuidanceAndAdviceActions.AddGuidanceAndAdvice({
        riskAndStaticQuestion: guidanceANdAdviceriskAndStaticQuestion
      }));
    }

    // retaining MU data detail store
    if (partialQuote.underwritingData && partialQuote.underwritingData.annuitantMedicalConditions && partialQuote.underwritingData.annuitantMedicalConditions[0]) {
      this.restoreValuesForMedicalUnderWrting(partialQuote);
    }

    // // Update personal detail store
    this.store.dispatch(new PersDetailsActions.RemovePersonalDetails(0));
    this.store.dispatch(new PersDetailsActions.AddPersonalDetails({
      contactNumber: resposeJsonLoggedInDetailStore ? resposeJsonLoggedInDetailStore['customer'].contactNumber : partialQuote['customer'].contactNumber,
      dateOfBirth: resposeJsonLoggedInDetailStore ? resposeJsonLoggedInDetailStore['customer'].dateOfBirth : partialQuote['customer'].dateOfBirth ? partialQuote['customer'].dateOfBirth.split('/').join(' / ') : null,
      emailAddress: resposeJsonLoggedInDetailStore ? resposeJsonLoggedInDetailStore['customer'].emailAddress : partialQuote['customer'].emailAddress,
      forename: resposeJsonLoggedInDetailStore ? partialQuote['customer'].forename : partialQuote['customer'].forename,
      gender: resposeJsonLoggedInDetailStore ? resposeJsonLoggedInDetailStore['customer'].gender : partialQuote['customer'].gender,
      maritalStatus: resposeJsonLoggedInDetailStore ? resposeJsonLoggedInDetailStore['customer'].maritalStatus : partialQuote['customer'].maritalStatus,
      postcode: resposeJsonLoggedInDetailStore ? resposeJsonLoggedInDetailStore['customer']['address'].postcode : partialQuote['customer']['address'].postcode,
      surname: resposeJsonLoggedInDetailStore ? partialQuote.customer.surname : partialQuote['customer'].surname,
      ukaddressIndicator: resposeJsonLoggedInDetailStore ? resposeJsonLoggedInDetailStore.customer.ukaddressIndicator : partialQuote['customer'].ukaddressIndicator,
      consentDate: isResumeQuote ? partialQuote.customer.consentDate : null,
      consentIndicator: isResumeQuote ? partialQuote.customer.consentIndicator : null,
      pwAppointmentdate: isResumeQuote? partialQuote.customer.pwAppointmentdate : null,
      customerCareInfo: isResumeQuote ? partialQuote.customer.customerCareInfo : null,
      internalSoftOptInInd: partialQuote.customer.internalSoftOptInInd
    }));
    // Update pension detail store
    let yourPensionRiskAndStaticQuestion = [];
    partialQuote.riskAndStaticQuestion.forEach(question => {
      if (question.questionCode === 'guaranteesQuestion' || question.questionCode === 'penaltiesQuestion') {
        yourPensionRiskAndStaticQuestion.push(question);
      }
    });
    const selectedFundProvider = UserDataConfig.ElementsConfig.sourcesListCvt.find(s => s.fundProvider === partialQuote.source);
    let cedingFund;
    let fundArray = [];
    if (partialQuote.fundModel !== null && partialQuote.fundModel.length > 0) {
      partialQuote.fundModel.map(element => {
        if (element.funds.length > 0) {
          let fundProvider = (element.policies.length > 0) ? element.policies[0].cedingProvider : '';
          element.funds.forEach((fund)=> {
            if ( fund.type === 'CDF') {
              fund.type = fund.type.replace('CDF',(fundProvider === 'B' ? 'Ext' : (fundProvider === 'I' ? 'Int.' : 'CDF')));
            }
            fundArray.push(fund);
          });
        }
      });
      cedingFund = fundArray.filter(element => {
        return (selectedFundProvider && partialQuote.source && element.type === selectedFundProvider.code && element.value > 0);
      })

      let yourPensionObj: YourPension = {
        aegon: { fundValue: null, transferType: "CDF", productCode: [] },
        external: { fundValue: null, transferType: "Ext", productCode: [] },
        internal: { fundValue: null, transferType: "Int.", productCode: [] },
        manualSource: null,
        cameFromMicrosite: partialQuote.cameFromMicrosite ? partialQuote.cameFromMicrosite : false,
        reAssure: { fundValue: null, transferType: "CDF", productCode: [] },
        sunLife: { fundValue: null, transferType: "CDF", productCode: [] },
        phoenixLife: { fundValue: null, transferType: "CDF", productCode: [] },
        pensionBee: { fundValue: null, transferType: "CDF", productCode: [] },
        aon: { fundValue: null, transferType: "CDF", productCode: [] },
        hsbc: { fundValue: null, transferType: "CDF", productCode: [] },
        guarantees: partialQuote.riskAndStaticQuestion.find(q => q.questionCode === 'guaranteesQuestion') ? partialQuote.riskAndStaticQuestion.find(q => q.questionCode === 'guaranteesQuestion').answer : null,
        penalties: partialQuote.riskAndStaticQuestion.find(q => q.questionCode === 'penaltiesQuestion') ? partialQuote.riskAndStaticQuestion.find(q => q.questionCode === 'penaltiesQuestion').answer : null,
        totalSum: benefitBasis ? benefitBasis.pensionFund : null,
        fundProvider: partialQuote.source ? partialQuote.source : null,
        riskAndStaticQuestion: yourPensionRiskAndStaticQuestion,
        cedingFund: cedingFund && cedingFund[0] ? cedingFund[0].value : null,
        productCodes: partialQuote['dealPartnerProductModel'] ?
          (partialQuote['dealPartnerProductModel']['productCodeModels'] ?
            partialQuote['dealPartnerProductModel']['productCodeModels'] : null) : null,
        benefitTypes: partialQuote['dealPartnerProductModel'] ?
          (partialQuote['dealPartnerProductModel']['benefitTypes'] ?
            partialQuote['dealPartnerProductModel']['benefitTypes'] : null) : null,
        fundValidateInd: partialQuote.fundValidateInd
      };

      
      partialQuote.fundModel.forEach(element => {
        let selectedFundValue: any;
        let differentProdCode: any;
        if ((element.policies.length > 0 && element.policies[0].cedingProvider === 'B')) {
          selectedFundValue = UserDataConfig.ElementsConfig.sourcesListCvt.find(cvt => cvt.code === 'Ext');
        } else {
          selectedFundValue = UserDataConfig.ElementsConfig.sourcesListCvt.find(cvt => cvt.fundProvider === partialQuote.source);
          // tslint:disable-next-line:max-line-length
          differentProdCode = [...Array.from(new Set(element.policies.map(item => item.productCode).filter(m => m != null && m !== '')))];
        }
        if (selectedFundValue) {
          let fundVal = element.funds.find(fund => fund.type !== 'Tfc');
          if (element.policies.length > 0 && (element.policies[0].cedingProvider === 'I' ||
          element.policies[0].cedingProvider === 'B' || element.policies[0].cedingProvider === 'L' || element.policies[0].cedingProvider === 'M')) {
            yourPensionObj[selectedFundValue.controlName] = {
              fundValue: (fundVal && fundVal.value) ? fundVal.value : null,
              transferType: selectedFundValue['code'],
              productCode: []
            };
          } else {
            yourPensionObj[selectedFundValue.controlName] = {
              fundValue: (fundVal && fundVal.value) ? fundVal.value : null,
              transferType: (element.funds[0] && element.funds[0].type) ? element.funds[0].type : null,
              productCode: differentProdCode
            };
          }

        }
      });
      if (this.getScreenNameID(partialQuote.currentScreen) >= 4 || yourPensionObj.fundProvider) {
        this.store.dispatch(new YourPensionActions.RemoveYourPension(0));
        this.store.dispatch(new YourPensionActions.AddYourPension({ ...yourPensionObj }));
      }
    }

    // Product Choice store updates
    let productChoiceRiskAndStaticQuestion = [];
    partialQuote.riskAndStaticQuestion.forEach(question => {
      // tslint:disable-next-line: max-line-length
      if (question.questionCode === 'pensionPotQuestion' || question.questionCode === 'lumpSumsQuestion' || question.questionCode === 'financialDependantsQuestion' || question.questionCode === 'withdrawingMoneyQuestion') {
        productChoiceRiskAndStaticQuestion.push(question);
      }
    });

    const productChoiceObj: ProductChoice = {
      selectedProduct: partialQuote.product,
      // tslint:disable-next-line: max-line-length
      productName: partialQuote.product !== '' ? UserDataConfigUserDetail.ElementsConfig.productChoice.products.find(p => p.productCode === partialQuote.product)['productName'] : '',
      // tslint:disable-next-line: max-line-length
      pensionPotQues: partialQuote.riskAndStaticQuestion.find(q => q.questionCode === 'pensionPotQuestion') ? partialQuote.riskAndStaticQuestion.find(q => q.questionCode === 'pensionPotQuestion').answer : null,
      // tslint:disable-next-line: max-line-length
      flexwithQues: partialQuote.riskAndStaticQuestion.find(q => q.questionCode === 'lumpSumsQuestion') ? partialQuote.riskAndStaticQuestion.find(q => q.questionCode === 'lumpSumsQuestion').answer : null,
      // tslint:disable-next-line: max-line-length
      financialDependantsQues: partialQuote.riskAndStaticQuestion.find(q => q.questionCode === 'financialDependantsQuestion') ? partialQuote.riskAndStaticQuestion.find(q => q.questionCode === 'financialDependantsQuestion').answer : null,
      // tslint:disable-next-line: max-line-length
      withdrawingMoneyQues: partialQuote.riskAndStaticQuestion.find(q => q.questionCode === 'withdrawingMoneyQuestion') ? partialQuote.riskAndStaticQuestion.find(q => q.questionCode === 'withdrawingMoneyQuestion').answer : null,
      source: partialQuote.source,
      productOptions: partialQuote.productOptions,
      riskAndStaticQuestion: productChoiceRiskAndStaticQuestion

    };
    if (partialQuote.product !== '') {
      this.store.dispatch(new ProductChoiceActions.RemoveProductChoice(0));
      this.store.dispatch(new ProductChoiceActions.AddProductChoice(productChoiceObj));
    }

    // Dependent Detail store updates
    let dependantRiskAndStaticQuestion = [];
    partialQuote.riskAndStaticQuestion.forEach(question => {
      // tslint:disable-next-line: max-line-length
      if (question.questionCode === 'dependantQuestion') {
        dependantRiskAndStaticQuestion.push(question);
      }
    });
    let DependantDetailsObj: DependantDetails = {
      dateOfBirth: partialQuote.secondLife && partialQuote.secondLife.dateOfBirth ? partialQuote.secondLife.dateOfBirth.split('/').join(' / ') : null,
      dependantQuestion: partialQuote.riskAndStaticQuestion.find(q => q.questionCode === 'dependantQuestion') ? partialQuote.riskAndStaticQuestion.find(q => q.questionCode === 'dependantQuestion').answer : '',
      gender: partialQuote.secondLife && partialQuote.secondLife.gender,
      relationship: partialQuote.secondLife && partialQuote.secondLife.relationshipToCustomer,
      riskAndStaticQuestion: dependantRiskAndStaticQuestion
    };
    this.store.dispatch(new DepDetailsActions.RemoveDependantDetails(0));
    this.store.dispatch(new DepDetailsActions.AddDependantDetails(DependantDetailsObj));
    
    const isdeptSelected = partialQuote.riskAndStaticQuestion.find(q => q.questionCode === 'dependantQuestion') ? partialQuote.riskAndStaticQuestion.find(q => q.questionCode === 'dependantQuestion').answer === 'Y' ? true : false : false;

    if (partialQuote.secondLife && isdeptSelected) {
      this.refreshBreadcrumb(true);
    }
    else {
      this.refreshBreadcrumb(false);
    }
    
    // populate both the  filed in Tax free in benefit basis
    if (!benefitBasis['extTaxFreeCashAmount'] && benefitBasis['extTaxFreeCashPercentage']) {
      // tslint:disable-next-line: max-line-length
      benefitBasis['extTaxFreeCashAmount'] = ((benefitBasis['extTaxFreeCashPercentage']) * (benefitBasis['externalFundAmount'])) / 100;

    }
    if (!benefitBasis['extTaxFreeCashPercentage'] && benefitBasis['extTaxFreeCashAmount']) {
      // tslint:disable-next-line: max-line-length
      benefitBasis['extTaxFreeCashPercentage'] = ((benefitBasis['extTaxFreeCashAmount']) / (benefitBasis['externalFundAmount'])) * 100;

    }
    if (!benefitBasis['taxFreeCashAmount'] && benefitBasis['taxFreeCashPercentage']) {
      // tslint:disable-next-line: max-line-length
      benefitBasis['taxFreeCashAmount'] = ((benefitBasis['taxFreeCashPercentage']) * (benefitBasis['cedingFundAmount'])) / 100;

    }
    if (!benefitBasis['taxFreeCashPercentage'] && benefitBasis['taxFreeCashAmount']) {
      // tslint:disable-next-line: max-line-length
      benefitBasis['taxFreeCashPercentage'] = ((benefitBasis['taxFreeCashAmount']) / (benefitBasis['cedingFundAmount'])) * 100;

    }
    // end populate both the filled in tax free in benefit basis
    let calculatedTaxFreeLumSum = [];
    if (partialQuote && partialQuote.fundModel && partialQuote.fundModel.length > 0) {
      let fundArray = [];
      partialQuote.fundModel.map(element => {
        if (element.funds.length > 0) {
          let fundProvider = (element.policies.length > 0) ? element.policies[0].cedingProvider : '';
          element.funds.forEach((fund)=> {
            if ( fund.type === 'CDF') {
              fund.type = fund.type.replace('CDF',(fundProvider === 'B' ? 'Ext' : 'CDF'));
            }
            fundArray.push(fund);
          });
        }
      });
      
      fundArray = fundArray.filter(quote => (quote.type !== 'Tfc' && (quote.value && quote.value > 0)));
      if ((partialQuote.quoteBasis.quoteType === 'IVPP' && partialQuote.source && partialQuote.source === 'B') || 
          (partialQuote.source && partialQuote.source === 'B' && partialQuote.product && partialQuote.product == 'H') 
       || (partialQuote.source && partialQuote.source === 'B' && partialQuote.product && partialQuote.product == 'G') ) {
        // tslint:disable-next-line: max-line-length
        calculatedTaxFreeLumSum.push({ mode: 'primary', value: benefitBasis['taxFreeCashAmount'], perc: benefitBasis['taxFreeCashPercentage'] });
      } else if (partialQuote.source && partialQuote.source === 'B') {
        // tslint:disable-next-line: max-line-length
        calculatedTaxFreeLumSum.push({ mode: 'secondary', value: benefitBasis['extTaxFreeCashAmount'], perc: benefitBasis['extTaxFreeCashPercentage'] });
      } else {
        fundArray.forEach((fund, i) => {
          // tslint:disable-next-line: max-line-length
          if (fund.type.toUpperCase() === 'EXT') {
            // tslint:disable-next-line: max-line-length
            calculatedTaxFreeLumSum.push({ mode: 'secondary', value: benefitBasis['extTaxFreeCashAmount'], perc: benefitBasis['extTaxFreeCashPercentage'] });
          } else {
            // tslint:disable-next-line: max-line-length
            calculatedTaxFreeLumSum.push({ mode: 'primary', value: benefitBasis['taxFreeCashAmount'], perc: benefitBasis['taxFreeCashPercentage'] });
          }
        });
      }

    }
    this.store.dispatch(new ReqQuoteCalcActions.RemoveReqQuoteCalculation(0));
    if (!isResumeQuoteOtherProd) {
      // tslint:disable-next-line: max-line-length
      if (partialQuote.product === 'C') {
        let valueprotection: string;
        if (benefitBasis['vpIndicator']) {
          valueprotection = benefitBasis['vpIndicator'];
        } else {
          if (benefitBasis['vpPercentage'] && benefitBasis['vpPercentage'] >= 0) {
            valueprotection = 'Ann';
          } else if (benefitBasis['guaranteedTerm'] && benefitBasis['guaranteedTerm'] >= 0) {
            valueprotection = 'Inc';
          } else if (!isResumeQuote && !isdeptSelected && !benefitBasis['vpPercentage'] &&
            benefitBasis['guaranteedTerm'] <= 0) {
            valueprotection = 'Ne';
          } else if (!isdeptSelected) {
            valueprotection = null;
          }
          if (isdeptSelected && benefitBasis['guaranteedTerm'] &&
            benefitBasis['guaranteedTerm'] >= 0 &&
            benefitBasis['secondLifePensionPercentage'] && benefitBasis['secondLifePensionPercentage'] >= 0) {
            valueprotection = 'Inc';

          } else if (isdeptSelected && benefitBasis['guaranteedTerm'] <= 0 &&
            benefitBasis['secondLifePensionPercentage'] &&
            benefitBasis['secondLifePensionPercentage'] <= 0) {
            valueprotection = 'Ne';
          }
        }
       


        this.store.dispatch(new ReqQuoteCalcActions.AddReqQuoteCalculation(
          {
            // quoteBasis benefitBasis LTA
            reQuoteFlag : isResumeQuote === true ? false : true,
            frequency: partialQuote.quoteBasis['paymentFrequency'],
            advance: partialQuote.quoteBasis['paymentAdvance'],
            // tslint:disable-next-line: max-line-length
            startDate: ((partialQuote.quoteBasis['commencementDate'] && isResumeQuote) ? partialQuote.quoteBasis['commencementDate'].replace(/\//g, ' / ') : ''),
            currentDate: (partialQuote.quoteBasis['startDateType'] === 'As Soon As Possible' ? 'A' : ''),
            // tslint:disable-next-line: max-line-length
            incomepercentage: benefitBasis['secondLifePensionPercentage'] ? benefitBasis['secondLifePensionPercentage'] : secondlifePercentage,
            increasedincome: benefitBasis['escalationType'],

            increasedincomeslider: benefitBasis['escalationRate'],
            valueprotection: valueprotection,
            vpslider: benefitBasis['vpPercentage'],

            periodofincome: benefitBasis['guaranteedTerm'],
            productType: partialQuote.product,
            taxfreelumpsum: benefitBasis['taxFreeCashPercentage'] ?
              benefitBasis['taxFreeCashPercentage'] : 0,
            taxfreelumpsumSecondary: benefitBasis['extTaxFreeCashPercentage'] ?
              benefitBasis['extTaxFreeCashPercentage'] : 0,
            taxfreeRadioButton: benefitBasis['taxFreeCashAmountPercent'] ?
              benefitBasis['taxFreeCashAmountPercent'] : '',
            taxfreeRadioButtonSecondary: benefitBasis['extTaxFreeCashAmountPercent'] ?
              benefitBasis['extTaxFreeCashAmountPercent'] : '',
            fundValueTaxfree: benefitBasis['taxFreeCashAmount'] ?
              benefitBasis['taxFreeCashAmount'] : 0,
            fundValueTaxfreeSecondary: benefitBasis['extTaxFreeCashAmount'] ?
              benefitBasis['extTaxFreeCashAmount'] : 0,
            // tslint:disable-next-line: max-line-length
            secondLifePensionPercentage: benefitBasis['secondLifePensionPercentage'] ? benefitBasis['secondLifePensionPercentage'] : secondlifePercentage,
            secondLifePensionPercentageType: benefitBasis['secondLifePensionPercentageType'],
            calculatedTaxFreeLumSum: calculatedTaxFreeLumSum 
          }
        ));

      } else if (partialQuote.product === 'H') {
        this.store.dispatch(new ReqQuoteCalcActions.AddReqQuoteCalculation(
          {
            // quoteBasis benefitBasis FTRP
            reQuoteFlag : false,
            frequency: partialQuote.quoteBasis['paymentFrequency'],
            advance: partialQuote.quoteBasis['paymentAdvance'],
            // tslint:disable-next-line: max-line-length
            startDate: ((partialQuote.quoteBasis['commencementDate'] && isResumeQuote) ? partialQuote.quoteBasis['commencementDate'].replace(/\//g, ' / ') : ''),
            currentDate: (partialQuote.quoteBasis['startDateType'] === 'As Soon As Possible' ? 'A' : ''),
            taxfreelumpsum: benefitBasis['taxFreeCashPercentage'] ?
              benefitBasis['taxFreeCashPercentage'] : 0,
            taxfreelumpsumSecondary: benefitBasis['extTaxFreeCashPercentage'] ?
              benefitBasis['extTaxFreeCashPercentage'] : 0,
            taxfreeRadioButton: benefitBasis['taxFreeCashAmountPercent'] ?
              benefitBasis['taxFreeCashAmountPercent'] : '',
            taxfreeRadioButtonSecondary: benefitBasis['extTaxFreeCashAmountPercent'] ?
              benefitBasis['extTaxFreeCashAmountPercent'] : '',
            fundValueTaxfree: benefitBasis['taxFreeCashAmount'] ?
              benefitBasis['taxFreeCashAmount'] : 0,
            fundValueTaxfreeSecondary: benefitBasis['extTaxFreeCashAmount'] ?
              benefitBasis['extTaxFreeCashAmount'] : 0,
            periodofincome: benefitBasis['guaranteedTerm'],
            periodofincomequestion: benefitBasis['guaranteedTermIndicator'],
            incomepercentage: benefitBasis['secondLifePensionPercentage'] ? benefitBasis['secondLifePensionPercentage'] : 0,
            increasedincome: benefitBasis['escalationType'],
            termplan: partialQuote.quoteBasis['policyTerm'],
            termmonth: partialQuote.quoteBasis['policyTermMonths'],
            incomematurity: benefitBasis['annualIncome'] === null ? (benefitBasis['maturityAmount'] === null ? null : 'M') : 'Y',
            fundValue: benefitBasis['annualIncome'] ? benefitBasis['annualIncome'] : benefitBasis['maturityAmount'],

            increasedincomeslider: benefitBasis['escalationRate'],
            productType: partialQuote.product,
            calculatedTaxFreeLumSum: calculatedTaxFreeLumSum
          }
        ));

      }
      else if (partialQuote.product === 'G') {
        this.store.dispatch(new ReqQuoteCalcActions.AddReqQuoteCalculation(
          {
            reQuoteFlag : false,
            termyear: partialQuote.quoteBasis['policyTerm'],
            termmonth: partialQuote.quoteBasis['policyTermMonths'],
            frequency: partialQuote.quoteBasis['paymentFrequency'],
            advance: partialQuote.quoteBasis['paymentAdvance'],
            // tslint:disable-next-line: max-line-length
            startDate: ((partialQuote.quoteBasis['commencementDate'] && isResumeQuote) ? partialQuote.quoteBasis['commencementDate'].replace(/\//g, ' / ') : ''),
            currentDate: (partialQuote.quoteBasis['startDateType'] === 'As Soon As Possible' ? 'A' : ''),
            taxfreelumpsum: benefitBasis['taxFreeCashPercentage'] ?
              benefitBasis['taxFreeCashPercentage'] : 0,
            taxfreelumpsumSecondary: benefitBasis['extTaxFreeCashPercentage'] ?
              benefitBasis['extTaxFreeCashPercentage'] : 0,
            taxfreeRadioButton: benefitBasis['taxFreeCashAmountPercent'] ?
              benefitBasis['taxFreeCashAmountPercent'] : '',
            taxfreeRadioButtonSecondary: benefitBasis['extTaxFreeCashAmountPercent'] ?
              benefitBasis['extTaxFreeCashAmountPercent'] : '',
            fundValueTaxfree: benefitBasis['taxFreeCashAmount'] ?
              benefitBasis['taxFreeCashAmount'] : 0,
            fundValueTaxfreeSecondary: benefitBasis['extTaxFreeCashAmount'] ?
              benefitBasis['extTaxFreeCashAmount'] : 0,
            increasedincome: benefitBasis['escalationType'],
            increasedincomeslider: benefitBasis['escalationRate'],  
            productType: partialQuote.product,
            calculatedTaxFreeLumSum: calculatedTaxFreeLumSum
          }
        ));
      }
    }

    this.store.dispatch(new resDataCalculationActions.RemoveQuoteCalculation(0));
    this.store.dispatch(new resDataCalculationActions.AddQuoteCalculation(partialQuote));

    this.store.dispatch(new resDataCaptureActions.RemoveQuoteCapture(0));
    this.store.dispatch(new resDataCaptureActions.AddQuoteCapture(partialQuote));

    //playback store
    const playbackRiskAndStaticQuestion = [];
    let overAllReturnQuestionType;
    if (partialQuote.product === 'H') {
      overAllReturnQuestionType = 'overAllReturnRiskQuestion';
    } else if (partialQuote.product === 'G') {
      overAllReturnQuestionType = 'overAllReturnRiskQuestion'
    }
    partialQuote.riskAndStaticQuestion.forEach(question => {
      // tslint:disable-next-line: max-line-length
      if (question.questionCode === 'taxPayRiskQuestion' || question.questionCode === 'inflationQuestion' || question.questionCode === 'claimPensionRiskQuestion' || question.questionCode === 'takeOutPensionRiskQuestion' || question.questionCode === overAllReturnQuestionType) {
        playbackRiskAndStaticQuestion.push(question);
      }
    });
    this.store.dispatch(new QuotePlaybackRiskWarningActions.RemoveQuotePlaybackRiskWarning(0));
    if (isResumeQuote || partialQuote['requote'] == true) {
      this.store.dispatch(new QuotePlaybackRiskWarningActions.AddQuotePlaybackRiskWarning(
        {
          // tslint:disable-next-line: max-line-length
          taxPayRisk: partialQuote.riskAndStaticQuestion.find(q => q.questionCode === 'taxPayRiskQuestion') ? partialQuote.riskAndStaticQuestion.find(q => q.questionCode === 'taxPayRiskQuestion').answer : null,
          // tslint:disable-next-line: max-line-length
          inflation: partialQuote.riskAndStaticQuestion.find(q => q.questionCode === 'inflationQuestion') ? partialQuote.riskAndStaticQuestion.find(q => q.questionCode === 'inflationQuestion').answer : null,
          // tslint:disable-next-line: max-line-length
          claimPensionRisk: partialQuote.riskAndStaticQuestion.find(q => q.questionCode === 'claimPensionRiskQuestion') ? partialQuote.riskAndStaticQuestion.find(q => q.questionCode === 'claimPensionRiskQuestion').answer : null,
          // tslint:disable-next-line: max-line-length
          takeOutPensionRisk: partialQuote.riskAndStaticQuestion.find(q => q.questionCode === 'takeOutPensionRiskQuestion') ? partialQuote.riskAndStaticQuestion.find(q => q.questionCode === 'takeOutPensionRiskQuestion').answer : null,
          // tslint:disable-next-line: max-line-length
          overAllReturnRisk: partialQuote.riskAndStaticQuestion.find(q => q.questionCode === overAllReturnQuestionType) ? partialQuote.riskAndStaticQuestion.find(q => q.questionCode === overAllReturnQuestionType).answer : null,
          riskAndStaticQuestion: playbackRiskAndStaticQuestion
        }
      ));

    }

    if (partialQuote.product === 'C') {
      this.refreshBreadcrumb({ hidden: false });
    } else if (partialQuote.product === 'H') {
      this.refreshBreadcrumb({ ftrpcorpBreadCrum: true });
    } else if (partialQuote.product === 'G') {
      this.refreshBreadcrumb({ ftrpcorpBreadCrum: true });
    }
    if (partialQuote.currentScreen.length <= 0) {
      partialQuote= {...partialQuote, currentScreen: 'guidanceAndAdvice'};
    }

    // Check new risk Questions are answered or not
    if(!partialQuote.riskAndStaticQuestion.find(q => q.questionCode === 'bookPensionWiseAppointmentQuestion') && !isforHoUnderwriting) {
      this.popUpGuidanceAndAdvice$.next("true");
    }
    else {
       // check  after login if customer has not select the correct relationnship then navigate to dependent detail page
      if (!isforHoUnderwriting && partialQuote.secondLife && partialQuote.secondLife.relationshipToCustomer) {
        if (partialQuote.customer.maritalStatus === 'S' || partialQuote.customer.maritalStatus === 'CH'
            || partialQuote.customer.maritalStatus === 'D'  || partialQuote.customer.maritalStatus === 'W' ) {
              if (partialQuote.secondLife.relationshipToCustomer && partialQuote.secondLife.relationshipToCustomer !== 'F') {
                this.router.navigate(['home/your-dependant'], { replaceUrl: true });
                return;
              }

          } else if (partialQuote.customer.maritalStatus === 'M') {
            if (partialQuote.secondLife.relationshipToCustomer && partialQuote.secondLife.relationshipToCustomer !== 'S') {
              this.router.navigate(['home/your-dependant'], { replaceUrl: true });
              return;
            }

          } else if (partialQuote.customer.maritalStatus === 'C') {
            if (partialQuote.secondLife.relationshipToCustome && partialQuote.secondLife.relationshipToCustomer !== 'R') {
              this.router.navigate(['home/your-dependant'], { replaceUrl: true });
              return;
            }
          } else if (partialQuote.customer.maritalStatus === 'SE') {
            if (partialQuote.secondLife.relationshipToCustomer && partialQuote.secondLife.relationshipToCustomer === 'F') {
              this.router.navigate(['home/your-dependant'], { replaceUrl: true });
              return;
            }
          }

      }
      if (!isforHoUnderwriting && partialQuote.customer && !partialQuote.customer.maritalStatus) {
        this.router.navigate(['home/update-my-details'], { replaceUrl: true });
        return;
      }
      if (isforHoUnderwriting) {
        if (partialQuote['underwriting']) {
          this.store.dispatch(new underWritingDataAction.RemoveUnderwritingData(0));
          this.store.dispatch(new underWritingDataAction.AddUnderwritingData(partialQuote['underwriting']));
        }
      } else if (partialQuote.currentScreen === "Medical condition questionnaire") {
        this.router.navigate([MEDICAL_UW_URL.annuitant.medicalConditions], { replaceUrl: true });
      } else if (partialQuote.currentScreen === "Your dependant - Medical condition questionnaire") {
        this.router.navigate([MEDICAL_UW_URL.dependant.dependantMedicalConditions], { replaceUrl: true });
      } else if (partialQuote.currentScreen === "Dependant’s amc") {
        this.router.navigate([MEDICAL_UW_URL.dependant.dependantMedicalConditions], { replaceUrl: true });
      } else if (partialQuote.currentScreen === "amc") {
        this.router.navigate([MEDICAL_UW_URL.annuitant.medicalConditions], { replaceUrl: true });
      } else if (partialQuote.currentScreen === "Dependant’s diabetes") {
        this.router.navigate([MEDICAL_UW_URL.dependant.dependantMedicalConditions], { replaceUrl: true });
      } else if (partialQuote.currentScreen === "diabetes") {
        this.router.navigate([MEDICAL_UW_URL.annuitant.medicalConditions], { replaceUrl: true });
      }
      else {
        this.router.navigate([this.getScreenName(partialQuote.currentScreen)], { replaceUrl: true });
      }
    }

  }

  restoreValuesForMedicalUnderWrting(partialQuoteObj: any) {
    let underWritingData = new UnderWritingData();
    underWritingData = partialQuoteObj.underwritingData;
    partialQuoteObj.riskAndStaticQuestion.forEach(question => {
      // tslint:disable-next-line: max-line-length
      if (question.questionCode === 'lifestyleRiskWarningQuestion') {
        underWritingData.riskAndStaticQuestion = question;
      }
    });
    if (underWritingData && underWritingData.annuitantMedicalConditions && underWritingData.annuitantMedicalConditions.length > 0) {
      underWritingData = { ...underWritingData, annuitantMedicalConditions: this.utilityServiceForMedicalService.sortMedicalConditions(underWritingData.annuitantMedicalConditions) }
    }
    if (underWritingData && underWritingData.dependentMedicalConditions && underWritingData.dependentMedicalConditions.length > 0) {
      underWritingData = { ...underWritingData, dependentMedicalConditions: this.utilityServiceForMedicalService.sortMedicalConditions(underWritingData.dependentMedicalConditions) }
    }
    this.store.dispatch(new LifeStyleActions.RemoveLifestyleResult(0));
    this.store.dispatch(new LifeStyleActions.AddLifestyleResult(underWritingData));

  }
  public getScreenName(currentscreen): string {
    const breadcrumbDetails = BreadCrumDataConfig.BreadcrumbConfig.data.values;
    return breadcrumbDetails.find(br => br['screenName'] === currentscreen).path;
  }
  public getScreenNameID(currentscreen): number {
    const breadcrumbDetails = BreadCrumDataConfig.BreadcrumbConfig.data.values;
    return breadcrumbDetails.find(br => br['screenName'] === (currentscreen === '' ? 'beforestart' : currentscreen)).id;
  }
  public toggleBreadcrumb(breadcrumbDetails, elemArray, flag) {
    breadcrumbDetails.filter((item) => {
      if (elemArray.includes(item.id)) {
        item.enable = flag;
      }
    });
  }
  isQuoteLocked(quoteRefNo: string): Observable<any> {
    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      return of(false);
    } else {
      return this.http.post<any>(this.endPoints.quoteLockedUrl, quoteRefNo).pipe(map((res: Response) => {
        return res;
      }));
    }
  }

  getCountryNames() {
    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {

      const accessURL = this.endPoints.getCountryNames;
      return this.http.get(accessURL);
    }
    else {
      return this.http.get(this.endPoints.getCountryNames);
    }
  }
  /** To get CMS   Data from JSON */
  getCMSData(cmsPageJSON: string): Observable<any> {
    return this.http.get(cmsPageJSON);
  }
  getCONFIGData(cmsPageJSON: string): Observable<any> {
    return this.http.get(cmsPageJSON);
  }
  public getScreenNameFromURL(URL) {
    const breadcrumbDetails = UserDataConfigBreadCrumbs.BreadcrumbConfig.data.values;
    const currentArray = breadcrumbDetails.filter((arr, index) => {
      return arr.path === URL.split('?')[0];
    });
    return currentArray[0].screenName;
  }
  navigatetopreviouspage() {
    const val = this.router.url;
    const currentBreadCrumb = UserDataConfigBreadCrumbs.BreadcrumbConfig.data.values.find(b => b.path === val);
    // tslint:disable-next-line: max-line-length
    const arrBreadcrumb = UserDataConfigBreadCrumbs.BreadcrumbConfig.data.values.filter(b => b.type === currentBreadCrumb.type).filter(c => c.enable);
    const indexOfCurrentBreadCrumb = arrBreadcrumb.findIndex(a => a.id === currentBreadCrumb.id);
    const NextBreadCrumb = arrBreadcrumb[indexOfCurrentBreadCrumb - 1].path;
    this.router.navigate([NextBreadCrumb]);
  }

  public getCurrentScreenName() {
    return this.getScreenNameFromURL(this.router.url);
  }

  loginDetails = () => {
    if (CURRENT_ENVIROMENT.environment !== 'localEnvironment') {
      // tslint:disable-next-line: max-line-length
      let serverName = '';
      if (document.location.href.toString().toUpperCase().includes('LOCALHOST')) {
        serverName = 'localhost';
      } else {
        if (document.location.href.indexOf('lgnet') > -1) {
          // tslint:disable-next-line: max-line-length
          serverName = document.location.href.substring(document.location.href.indexOf('//') + 2, document.location.href.indexOf('lgnet') - 1);
        } else {
          // tslint:disable-next-line: max-line-length
          serverName = document.location.href.substring(document.location.href.indexOf('//') + 2, document.location.href.indexOf('landg') - 1);
        }
      }
      const configServername = this.serverDetail.find(s => s.serverName === serverName);
     
      this.loginRedirect(`${configServername.secAuthUrl}/SAuthGateWeb/login.html?domain=dcj&entryPoint=${configServername.entryPointUrl}%2Feap%2Frequest%2Fdcj%2FcustomerLogin`);
    } else {
       
    }
  }
  
  loginRedirect(url: string) {
    window.open(url, '_self');
  }

  newBeneficaryData(beneficiaryData, partialData){
    if (beneficiaryData && beneficiaryData.length > 0) {
      return beneficiaryData.map((beneficiaryInfo) => {
        return {
          userTitle: beneficiaryInfo && beneficiaryInfo.title ? beneficiaryInfo.title : '',
          otherTitle: beneficiaryInfo && beneficiaryInfo.otherTitle ? beneficiaryInfo.otherTitle : '',
          forename: beneficiaryInfo && beneficiaryInfo.forename ? beneficiaryInfo.forename : '',
          surname: beneficiaryInfo && beneficiaryInfo.surname ? beneficiaryInfo.surname : '',
          dateOfBirth: beneficiaryInfo && beneficiaryInfo.dob ? beneficiaryInfo.dob.toString().split('/').join(' / ')  : '',
          beneficiaryAllocPercentage: beneficiaryInfo && beneficiaryInfo.beneficiaryAllocPercentage ? beneficiaryInfo.beneficiaryAllocPercentage : '',
          ukAddressIndicator: beneficiaryInfo && beneficiaryInfo.ukAddressIndicator ? beneficiaryInfo.ukAddressIndicator : '',
          address: {
            addressline1: beneficiaryInfo?.address?.line1 ?? (beneficiaryInfo?.ukAddressIndicator === 'Y' ? partialData.customer.address.line1 : ''),
            addressline2: beneficiaryInfo?.address?.line2 ?? (beneficiaryInfo?.ukAddressIndicator === 'Y' ? partialData.customer.address.line2 : ''),
            addressline3: beneficiaryInfo?.address?.line3 ?? (beneficiaryInfo?.ukAddressIndicator === 'Y' ? partialData.customer.address.line3 : ''),
            addressline4: beneficiaryInfo?.address?.line4 ?? (beneficiaryInfo?.ukAddressIndicator === 'Y' ? partialData.customer.address.line4 : ''),
            postcode: beneficiaryInfo?.address?.postcode ?? (beneficiaryInfo?.ukAddressIndicator === 'Y' ? partialData.customer.address.postcode : ''),
            countryCode: beneficiaryInfo?.address?.countryCode ?? (beneficiaryInfo?.ukAddressIndicator === 'Y' ? partialData.customer.address.countryCode : ''),
          }
        }
      })
    } else if(beneficiaryData == null || beneficiaryData == '') {
       return []
    } else {
      return [
        {
          userTitle: beneficiaryData && beneficiaryData.title ? beneficiaryData.title : '',
          otherTitle: beneficiaryData && beneficiaryData.otherTitle ? beneficiaryData.otherTitle : '',
          forename: beneficiaryData && beneficiaryData.forename ? beneficiaryData.forename : '',
          surname: beneficiaryData && beneficiaryData.surname ? beneficiaryData.surname : '',
          dateOfBirth: beneficiaryData && beneficiaryData.dob ? beneficiaryData.dob.toString().split('/').join(' / ')  : '',
          beneficiaryAllocPercentage: beneficiaryData && beneficiaryData.beneficiaryAllocPercentage ? beneficiaryData.beneficiaryAllocPercentage : '',
          ukaddressIndicator: beneficiaryData && beneficiaryData.ukaddressIndicator ? beneficiaryData.ukaddressIndicator : '',
          address: {
            addressline1: beneficiaryData && beneficiaryData.address && beneficiaryData.address.line1 ? beneficiaryData.address.line1 : '',
            addressline2: beneficiaryData && beneficiaryData.address && beneficiaryData.address.line2 ? beneficiaryData.address.line2 : '',
            addressline3: beneficiaryData && beneficiaryData.address && beneficiaryData.address.line3 ? beneficiaryData.address.line3 : '',
            addressline4: beneficiaryData && beneficiaryData.address && beneficiaryData.address.line4 ? beneficiaryData.address.line4 : '',
            postcode: beneficiaryData && beneficiaryData.address && beneficiaryData.address.postcode ? beneficiaryData.address.postcode : '',
            countryCode: beneficiaryData && beneficiaryData.address && beneficiaryData.address.countryCode ? beneficiaryData.address.countryCode : '',
          }
        }
      ]
    }
  }
  checkForNonUKBankDispaly() {
    let nonUkBankSources = ['H', 'I', 'J', 'K', 'O'];
    const sourceCheck = nonUkBankSources.some(value => value === this.quoteResulRes?.source);
    return sourceCheck && (this.quoteResulRes && this.quoteResulRes.product && this.quoteResulRes.product === quoteLevelConstants.products.lta) ? true : false;
  }
}
